var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrightness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#D9E5F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 29.9966C14.4771 29.9966 10 25.5194 10 19.9966C10 14.4737 14.4771 9.99658 20 9.99658C25.5228 9.99658 30 14.4737 30 19.9966C30 25.5194 25.5228 29.9966 20 29.9966ZM20 27.9966C24.4183 27.9966 28 24.4149 28 19.9966C28 15.5783 24.4183 11.9966 20 11.9966C15.5817 11.9966 12 15.5783 12 19.9966C12 24.4149 15.5817 27.9966 20 27.9966ZM20 25.9966V13.9966C23.3137 13.9966 26 16.6829 26 19.9966C26 23.3103 23.3137 25.9966 20 25.9966Z",
    fill: "#3F7CDB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrightness);
export default __webpack_public_path__ + "static/media/brightness.3c4f3711f5d09233434d014ad04cc7f4.svg";
export { ForwardRef as ReactComponent };